import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import safeStyle from 'webapp/helpers/safe-style';
import ToolTipComponent from 'webapp/components/tool-tip';

import type Board from 'webapp/models-custom/board';

interface Args {
	model: Board;
	selectedId: string;
	onOpen: (id: string) => void;
}

export default class BoardsTabsNavItemComponent extends Component<Args> {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('account') declare accountService: Service.Account;

	get isSelected() {
		return this.args.model.id === this.args.selectedId;
	}

	@action
	editBoard() {
		if (this.accountService.handleDemo()) {
			return;
		}

		this.navigationService.transitionToRoute('designer.board', this.args.model.model);
	}

	@action
	openBoard() {
		if (this.isSelected) {
			if (this.args.model.canCurrentUserEdit) {
				this.editBoard();
			}
		} else {
			this.args.onOpen(this.args.model.id!);
		}
	}
	<template>
		<li
			class="{{if this.isSelected 'selected'}} {{if @model.canCurrentUserEdit 'editable'}}"
			data-id={{@model.id}}
		>
			<a role="button" {{on "click" this.openBoard}}>
				<span style={{safeStyle @model.color property="border-bottom-color"}}>
					{{@model.name}}
					<ToolTipComponent @text={{@model.name}} @showOnlyIfTruncated={{true}} />
				</span>
				{{#if @model.canCurrentUserEdit}}
					<em>edit</em>
				{{/if}}
			</a>
		</li>
	</template>
}
